import { createContext, ReactNode, useContext } from 'react'
import { useWebSocket, UseWebSocketReturn } from '@/hooks/useWebSocket'

const WebSocketContext = createContext<UseWebSocketReturn | null>(null)

export function WebSocketProvider({ children }: { children: ReactNode }) {
  const ws = useWebSocket()
  return (
    <WebSocketContext.Provider value={ws}>{children}</WebSocketContext.Provider>
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export function useWebSocketContext(): UseWebSocketReturn {
  const ctx = useContext(WebSocketContext)
  if (!ctx) {
    throw new Error(
      'useWebSocketContext must be used inside <WebSocketProvider>'
    )
  }
  return ctx
}
